import { officeInvoiceIsPaid } from 'components/InvoicePaymentAudit';
import React from 'react';
import styled from 'styled-components';
import { InvoiceSectionProps } from '../../types';
import { 
  PaymentCard,
  PaymentHeader,
  IconWrapper,
  PaymentInfo,
  PaymentTitle,
  PaymentSubtitle,
  InvoiceLink,
  StatusRow,
  StatusLabel,
  StatusBadge
} from '../../styles';

const PaymentStatusRow = styled(StatusRow)`
  padding: 16px;
  background: white;
  margin: 0 16px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

const InvoiceSection: React.FC<InvoiceSectionProps> = ({ hasInvoice, invoice, paymentTerms, onViewInvoice }) => {
  const isPaid = officeInvoiceIsPaid(invoice);

  // Convert payment terms to display text
  const getPaymentTermsText = (days?: number) => {
    switch (days) {
      case 1:
        return 'Within 24hrs of the Shift';
      case 5:
        return 'Within 5 Days of the Shift';
      case 14:
        return 'Within 2 Weeks of the Shift';
      case 30:
        return 'Within 1 Month of the Shift';
      default:
        return 'Within 2 Weeks of the Shift'; // Default fallback
    }
  };

  // Determine invoice action text and button display
  const getInvoiceActionElement = () => {
    if (!hasInvoice) {
      return null;
    }
    
    if (isPaid) {
      return (
        <InvoiceLink onClick={onViewInvoice}>
          View Invoice
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </InvoiceLink>
      );
    } else {
      return (
        <InvoiceLink onClick={onViewInvoice}>
          View & Pay Invoice
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </InvoiceLink>
      );
    }
  };

  return (
    <>
      <PaymentCard>
        <PaymentHeader>
          <IconWrapper>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 7V17M9 10C9 10 9.5 9 12 9C14.5 9 15 10 15 11C15 12 14.5 13 12 13C9.5 13 9 14 9 15C9 16 9.5 17 12 17C14.5 17 15 16 15 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </IconWrapper>
          <PaymentInfo>
            <PaymentTitle>Office Expected to Pay:</PaymentTitle>
            <PaymentSubtitle>{getPaymentTermsText(paymentTerms)}</PaymentSubtitle>
          </PaymentInfo>
        </PaymentHeader>
        {getInvoiceActionElement()}
      </PaymentCard>

      <PaymentStatusRow>
        <StatusLabel>Payment Status</StatusLabel>
        <StatusBadge $status={hasInvoice ? (isPaid ? 'done' : 'pending') : 'not-received'}>
          {hasInvoice ? (isPaid ? 'Paid!' : 'Pending') : 'Invoice has not been received yet'}
        </StatusBadge>
      </PaymentStatusRow>
    </>
  );
};

export default InvoiceSection; 